import AssetManagement from './AssetManagement';
import { createAssetManagementHandle } from './handle';

export default {
  Component: AssetManagement,
  createHandle: createAssetManagementHandle
};
